import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {RestApiService} from '../../../../core/services/http/rest-api.service';
import {Observable} from 'rxjs';
import {ApiCreateBoxResponse} from './api-create-box-response';
import {ApiRoutesEnum} from '../../../../core/services/http/api-routes.enum';
import {ApiBoxesListPaginatedQueryParams} from './api-boxes-list-paginated-query-params';
import {ApiBoxesListResponse} from './api-boxes-list-response';
import {ApiBoxResponse} from './api-box-response';
import {ApiBatchCreateBoxRequest} from './api-batch-create-box-request';
import {ApiBatchUpdateBoxHealthCenterBoxRequest} from './api-batch-update-box-health-center';
import {ApiSendBundleRequest} from './api-send-bundle-request';

@Injectable()
export class BoxRestApiService {

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _restApiService: RestApiService,
  ) {
  }

  public requestBatchCreate(data: ApiBatchCreateBoxRequest): Observable<Array<ApiCreateBoxResponse>> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.BOXES_BATCH_CREATE,
    ].join('/');
    return this._httpClient.post<Array<ApiCreateBoxResponse>>(url, data);
  }

  public requestBatchUpdateHeathCenter(data: ApiBatchUpdateBoxHealthCenterBoxRequest): Observable<void> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.BOXES_BATCH_CREATE,
    ].join('/');
    return this._httpClient.put<void>(url, data);
  }

  public requestBoxListPaginated(queryParams: ApiBoxesListPaginatedQueryParams): Observable<ApiBoxesListResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.BOXES,
    ].join('/');
    const params: HttpParams = this._restApiService.createHttpParams(queryParams);
    return this._httpClient.get<ApiBoxesListResponse>(url, {params: params});
  }

  public requestBox(boxId: string): Observable<ApiBoxResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.BOXES,
      boxId,
    ].join('/');
    return this._httpClient.get<ApiBoxResponse>(url);
  }

  public requestSendBundle(data: ApiSendBundleRequest): Observable<void> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.BOXES,
      ApiRoutesEnum.BOXES_SEND_TO_SUBCONTRACTOR,
    ].join('/');
    return this._httpClient.post<void>(url, data);
  }
}
